import React, { FC, useMemo } from "react";
import { useAppContext } from "../../Unknown/AppContext";
import useRows from "./useRows";
import AppointmentAIReportsTableGrid from "../AppointmentAIReportsTableGrid";
import { DashboardAppointmentAIReport } from "../AppointmentAIReportsTableContainer/getAppointmentAIReports";
import { ShowApprovedSwitchProps } from "../AppointmentAIReportsTableTopBar";
import { GridSortItem } from "../../Unknown/DataGrid";

type AppointmentAIReportsRoleTableProps = {
  role: string | undefined;
  appointmentAIReports: DashboardAppointmentAIReport[];
  isLoading: boolean;
  showApprovedProps: ShowApprovedSwitchProps;
  sortModel: GridSortItem[];
  setSortModel: (newModel: GridSortItem[]) => void;
  onReviewClick?: (id: number) => void;
  onEditClick?: (id: number) => void;
};

const AppointmentAIReportsRoleTable: FC<AppointmentAIReportsRoleTableProps> = ({
  role,
  appointmentAIReports,
  isLoading,
  showApprovedProps,
  sortModel,
  setSortModel,
  onReviewClick,
  onEditClick,
}) => {
  const { databaseUserData } = useAppContext();

  const rows = useRows(appointmentAIReports);

  const isSuperAdmin = useMemo(() => {
    return databaseUserData.roles.some(
      (userRole) => userRole.role === "super_admin",
    );
  }, [databaseUserData.roles]);

  if (!databaseUserData || !databaseUserData.centerIds) return null;

  const localeFormat =
    databaseUserData.centerIds.length === 1 ? "center" : "client";

  if (
    !role ||
    !["receptionist", "radiologist", "technologist"].includes(role)
  ) {
    return null;
  }

  return (
    <AppointmentAIReportsTableGrid
      columnsConfig={{
        columnItems: [
          { field: "alert", isDeliveryShown: true },
          { field: "status" },
          { field: "patient", localeFormat },
          { field: "time", localeFormat },
          { field: "location" },
          { field: "studies" },
          { field: "btnView" },
          { field: "btnReview" },
        ],
        onReviewClick: isSuperAdmin ? onReviewClick : undefined,
        onEditClick: isSuperAdmin ? onEditClick : undefined,
      }}
      sortModel={sortModel}
      setSortModel={setSortModel}
      rows={rows}
      isLoading={isLoading}
      showApprovedProps={showApprovedProps}
    />
  );
};

export default AppointmentAIReportsRoleTable;
